import { render, staticRenderFns } from "./global-msg-alert.vue?vue&type=template&id=1cfc03d4"
import script from "./global-msg-alert.vue?vue&type=script&lang=js"
export * from "./global-msg-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports